import { UserButton } from '@clerk/clerk-react';
import { Icon } from '@/lib/icons';
import { IqName } from '@/components/IqName';
import { useSearch } from './search';
import { Softphone } from '@/phone/Softphone';

export function Topbar({ title, onMenu }: { title: string; onMenu?: () => void }) {
  const { query, setQuery } = useSearch();
  return (
    <header className="dash-top">
      <button className="dash-top__menu" type="button" onClick={onMenu} aria-label="Open menu">
        <Icon name="menu" size={22} />
      </button>
      <div className="dash-top__title">
        <h1><IqName text={title} /></h1>
      </div>
      <div className="dash-top__tools">
        <div className="dash-search">
          <Icon name="search" size={16} />
          <input placeholder="Search…" value={query} onChange={(e) => setQuery(e.target.value)} />
          {query && (
            <button className="dash-search__clear" aria-label="Clear search" onClick={() => setQuery('')}>
              <Icon name="x" size={14} />
            </button>
          )}
        </div>
        <Softphone />
        <UserButton appearance={{ elements: { avatarBox: { width: 36, height: 36 } } }} />
      </div>
    </header>
  );
}
